"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function RingingIcon() {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink", width: "16", height: "16", viewBox: "0 0 16 16" },
        React.createElement("defs", null,
            React.createElement("polygon", { id: "ready-a", points: "0 16 16 16 16 0 0 0" })),
        React.createElement("g", { fill: "none", fillRule: "evenodd" },
            React.createElement("path", { fill: "#0098DB", d: "M16,8 C16,12.418 12.418,16 8,16 C3.582,16 0,12.418 0,8 C0,3.582 3.582,0 8,0 C12.418,0 16,3.582 16,8" }),
            React.createElement("polygon", { fill: "#FFF", points: "3 5.349 3 8.645 7.376 13 10.658 13 12 11.655 10.114 9.72 8.178 11.655 4.312 7.823 6.273 5.921 4.343 4" }),
            React.createElement("path", { fill: "#FFF", d: "M12,7 C12,5.594 10.516,4 9,4 L9,2.334 C11.342,2.484 13.359,4 13.685,7 L12,7 Z" }),
            React.createElement("mask", { id: "ready-b", fill: "#fff" },
                React.createElement("use", { xlinkHref: "#ready-a" })),
            React.createElement("polygon", { fill: "#FFF", points: "9 7 10 7 10 6 9 6", mask: "url(#ready-b)" }))));
}
exports.RingingIcon = RingingIcon;
